import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { mapValues } from 'lodash'
import type { TPoint, TProperty } from 'stores/fieldAssetStore/helperTypes'

export type TPressureSensorZones = {
  zoneIds: number[]
  zoneName: string
}

export const getZonesByEmitterType = (
  property: TProperty,
  point: TPoint,
): Partial<Record<TEmitterType, TPressureSensorZones>> => {
  const zonesByEmitterType: Partial<Record<TEmitterType, { zoneIds: number[]; names: string[] }>> = {}
  const zoneEmitterIds = point.irrigationEmitterZoneIds ?? []

  zoneEmitterIds.forEach((zoneEmitterId) => {
    const [zoneId, emitterType] = zoneEmitterId.split('|||') as [string, TEmitterType]

    const zoneName =
      property.irrigationZones?.[Number(zoneId)]?.name ??
      property.irrigationZoneEmitters?.[zoneEmitterId]?.name

    if (!zoneName) return

    const zones = (zonesByEmitterType[emitterType] ??= { zoneIds: [], names: [] })

    zones.zoneIds.push(Number(zoneId))

    zones.names.push(zoneName)
  })

  return mapValues(zonesByEmitterType, (zones = { zoneIds: [], names: [] }) => ({
    zoneIds: zones.zoneIds,
    zoneName: [...new Set(zones.names)].sort((a, b) => a.localeCompare(b)).join(', '),
  }))
}
